import template from './index.html'
import ko from 'knockout'
import Base from '../../core/base'
import getLang from '../../i18n'
import debounce from 'lodash/debounce'
import {
  changeStyleMixin,
  gridRefMixin
} from '../../mixin'
import {
  isInteger,
  isPositiveInteger,
  isPositivenumber
} from '../../util/formatFunc'
const _INTERGER = 'integer'
const _POSITIVEINTEGER = 'positiveinteger'
const _POSITIVENUMBER = 'positivenumber'
const _CUSTOMTYPELIST = [_INTERGER, _POSITIVEINTEGER, _POSITIVENUMBER]
class Textarea extends Base {
  initialize (params) {
    this.value = params.value || ko.observable()
    this.fieldid = params.fieldid || this.value._fieldid || ''
    // textarea的行，默认两行
    this.rows = params.rows || '2'
    this.resizeType = params.resizeType || ''
    this.placeholder = params.placeholder || ''
    this.maxlength = params.maxlength
    if (ko.isObservable(params.disabled)) {
      this.disabled = params.disabled
    } else if (params.disabled) {
      this.disabled = ko.observable(!!params.disabled)
    } else {
      this.disabled = ko.observable(false)
    }
    // textarea是否可以自动变高，如果参数为‘true’则可以，默认不可以
    this.autoHeightChange = params.autoHeightChange || false
    // textarea是否显示计数，
    this.showCount = !!params.showCount
    if (this.showCount) {
      let that = this
      this.remainWords = ko.pureComputed({
        // 获取数据时通过value动态计算
        read: function () {
          if (that.value()) {
            return that.maxlength - that.value().toString().length
          } else {
            return that.maxlength
          }
        },
        // 设置的时候动态改变value值
        write: function (val) {
          that.value(val)
        }
      })
      this.countMsg = ko.computed(() => {
        return `${ getLang('限') } ${ this.maxlength } ${ getLang('字') },${ getLang('还可输入') } <span class="remain-words">${ this.remainWords() }</span> ${ getLang('字') }`
      })
    }
    changeStyleMixin.call(this, params)
  }
  methods (params) {
    gridRefMixin.call(this, params)
    this.setFocus = () => {
      this.$el.querySelector('textarea').focus()
      this.$el.querySelector('textarea').click()
    }
    // 默认校验
    this.defaultValidate = (vm, e) => {
      if (_CUSTOMTYPELIST.indexOf(params.type) > -1) {
        switch (params.type) {
          case _INTERGER:
            return isInteger.call(this, 'textarea')
          case _POSITIVEINTEGER:
            return isPositiveInteger.call(this, 'textarea')
          case _POSITIVENUMBER:
            return isPositivenumber.call(this, 'textarea')
        }
      } else {
        return true
      }
    }
    this.calcRemainWords = debounce((e) => {
      this.remainWords(e.target.value)
    }, 200)
    this.onKeyup = (a, e) => {
      params.onKeyup && params.onKeyup()
      this.defaultValidate()
      if (this.showCount) {
        this.calcRemainWords(e)
      }
    }
    this.onInput = (a, e) => {
      this.defaultValidate()
      if (this.showCount) {
        this.calcRemainWords(e)
      }
      params.onInput && params.onInput(e)
      if (this.autoHeightChange) {
        var el = e.target
        el.style.height = 'auto'
        el.style.height = el.scrollHeight + 'px'
        el.style.overflowY = 'hidden'
      }
      if (this.enableChangingStyle) {
        if (String(this.oldValue) !== String(e.target.value)) {
          this.textChanged(true)
        } else {
          this.textChanged(false)
        }
      }
    }
    this.onClick = (a, b) => {
      if (this.autoHeightChange) {
        var el = b.target
        el.style.height = 'auto'
        el.style.height = el.scrollHeight + 'px'
        el.style.overflowY = 'hidden'
      }
    }
    this.onBlur = (a, b) => {
      params.onBlur && params.onBlur(b)
      if (this.autoHeightChange) {
        var el = b.target
        el.style.height = 'auto'
        el.style.height = el.scrollHeight + 'px'
        el.style.overflowY = 'hidden'
      }
    }
  }
}
export default {
  name: 'textarea',
  init: Base.createViewModel(Textarea),
  template
}



// WEBPACK FOOTER //
// ./src/components/textarea/index.js